import React from "react";
import { Tabs, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import ManageCategories from "./ManageCategories";
const { Title } = Typography;
export default function Index() {
  const styles = { marginTop: "1.5rem" };
  return (
    <div>
      {/* <Row style={styles} align="middle" justify="space-between">
        <Col>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/"> Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Create Collection</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row style={styles}>
        <Col>
          <Title level={3}>User Settings</Title>
        </Col>
      </Row> */}

      <Row style={styles}>
        <Tabs defaultActiveKey="1" type="line" tabPosition={"left"}>
          <Tabs.TabPane tab="Categories" key="1">
            <ManageCategories />
          </Tabs.TabPane>
        </Tabs>
      </Row>
    </div>
  );
}
